const styles = (theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    bannerImage: {
        height: '350px',
        width: '100%',
        objectFit: 'cover',
        [theme.breakpoints.down('sm')]: {
            height: '300px',
        },
    },

    /****************
     * PROFILE CARD *
     ****************/
    offsetCard: {
        position: 'relative',
        bottom: theme.spacing(8),
    },
    profileCardContainer: {
        paddingTop: theme.spacing(1),
    },
    profileImage: {
        height: '250px',
        width: '250px',
        objectFit: 'cover',
        borderRadius: '0px',
        borderRadius: '4%',
        [theme.breakpoints.down('xs')]: {
            height: '2.8em',
            width: '2.8em',
            borderRadius: '5%',
        },
        backgroundColor: theme.palette.branding.elevator_grey_light,
        fontSize: theme.typography.pxToRem(40),
    },
    username: {
        fontSize: '1.7em',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.5em',
        },
        fontWeight: '700',
        wordBreak: 'break-all',
    },
    preferredUsername: {
        display: 'block',
        color: theme.palette.branding.elevator_red,
        textDecoration: 'none',
        fontWeight: 'bold',
    },
    role: {
        fontWeight: 'bold',
    },
    usernameBreakWordPolicy: {
        wordBreak: 'keep-all',
    },
    badgeGroupContainer: {
        display: 'inline-block',
    },
    badgeGroupInnerContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    bioText: {
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        hyphens: 'auto',
    },

    /*******************
     * BORDERED BUTTON *
     *******************/

    button: {
        border: '2px solid black',
        padding: theme.spacing(0, 2),
    },
    buttonIcon: {
        fontSize: theme.typography.pxToRem(12),
    },
    loadMoreButton: {
        border: '2px solid black',
        padding: theme.spacing(1),
    },

    /*********
     * POSTS *
     *********/
    emptyState: {
        textTransform: 'uppercase',
        color: theme.palette.common.black + '33',
    },
});

export default styles;
